// 刚刚爆料 · 单页资讯站 mock 数据（虚构人物与情节，仅用于演示内容结构与视觉）
// 每个分类与条目都围绕“明星 / 网红主播 / 公众人物大V / 娱乐圈动态”的追瓜主题编写。

export type TickerItem = { text: string; tag: string };

export const tickerItems: TickerItem[] = [
  { text: "顶流剧《烟雨长街》开机路透流出，番位之争火速登顶热搜", tag: "现场" },
  { text: "百万粉丝美妆主播被爆带货翻车，昨晚直播流泪道歉", tag: "网红" },
  { text: "某顶流运动员宣布退赛，评论区一夜涌进十万条留言", tag: "体娱" },
  { text: "选秀系爱豆新综艺官宣定档，导师阵容引发全网考古", tag: "综艺" },
  { text: "顶流歌手新专辑封面被指撞款，工作室深夜回应", tag: "实锤" },
  { text: "某影帝被拍深夜同行，狗仔称已在蹲守两周", tag: "独家" },
];

export type HeroStory = {
  kicker: string;
  title: string;
  lead: string;
  tag: string;
  time: string;
  image: string;
  readText: string;
  list: { rank: string; title: string; desc: string }[];
};

export const heroStory: HeroStory = {
  kicker: "刚刚 · 独家现场",
  title: "《烟雨长街》开机第一周：番位、剧本与绯闻，三把火同时烧上热搜",
  lead: "路透画面里，两位领衔主演全程零同框、零交流，而各自的超话却隔空打得火热。片方越是不回应，网友越是扒得深——这场开机即开战的“宫心计”，恐怕才刚开始。",
  tag: "娱乐圈动态",
  time: "38分钟前更新",
  image:
    "https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20press%20stage%20scene%2C%20dramatic%20crimson%20spotlights%20cutting%20through%20haze%20over%20an%20empty%20dark%20film%20set%2C%20camera%20silhouettes%20and%20film%20clapper%20in%20foreground%2C%20editorial%20magazine%20mood%2C%20warm%20vermillion%20and%20amber%20palette%2C%20high%20contrast%20dramatic%20lighting&width=1600&height=900&seq=gossip-hero-01&orientation=landscape",
  readText: "约 6 分钟可读完",
  list: [
    { rank: "01", title: "番位表被网友逐帧分析", desc: "官方海报人物站位引发两派粉丝隔空对线，官微评论区已沦陷。" },
    { rank: "02", title: "原定编剧中途换血", desc: "有业内人士侧面印证剧本历经三次大改，主演进组时间也因此延后。" },
    { rank: "03", title: "男主与女二被扒旧交集", desc: "多年前同框旧照被重新翻出，关于“真CP”还是“纯营业”的争论持续升温。" },
  ],
};

export const hotSearch: { word: string; heat: string }[] = [
  { word: "烟雨长街番位", heat: "568万" },
  { word: "美妆主播翻车", heat: "492万" },
  { word: "影帝被拍同行", heat: "410万" },
  { word: "顶流退赛", heat: "388万" },
  { word: "爱豆考古", heat: "302万" },
  { word: "撞款封面", heat: "277万" },
  { word: "营业cp", heat: "245万" },
  { word: "路透cp粉", heat: "198万" },
];

export type HotItem = {
  rank: string;
  title: string;
  hot: number;
  up: boolean;
  stable: boolean;
  tag: string;
  desc: string;
};

export const trending: HotItem[] = [
  { rank: "1", title: "苏晚晴直播首度回应婚变传闻", hot: 981, up: true, stable: false, tag: "网红主播", desc: "三分钟回应信息量爆炸，网友逐句拆解" },
  { rank: "2", title: "沈叙白新剧路透被指“番位压番”", hot: 956, up: true, stable: false, tag: "明星", desc: "片方海报站位引发两派粉丝隔空对线" },
  { rank: "3", title: "影帝顾沉舟深夜同行对象成谜", hot: 902, up: true, stable: false, tag: "娱乐圈", desc: "狗仔称已蹲守两周，全城追瓜" },
  { rank: "4", title: "选秀系爱豆韩屿川综艺官宣定档", hot: 870, stable: true, up: false, tag: "综艺", desc: "导师阵容引发全网考古潮" },
  { rank: "5", title: "头部主播孟离带货清单被逐项盘点", hot: 803, stable: true, up: false, tag: "网红主播", desc: "网友：价格实惠就认，翻车就锤" },
  { rank: "6", title: "音乐人程野新专封面被指撞款", hot: 745, up: true, stable: false, tag: "娱乐圈", desc: "工作室深夜发文回应设计灵感" },
  { rank: "7", title: "顶流运动员魏星野宣布退赛", hot: 690, stable: true, up: false, tag: "体娱", desc: "评论区一夜涌入十万条留言" },
  { rank: "8", title: "童星出身的许之遥晒新角色定妆", hot: 655, up: false, stable: true, tag: "明星", desc: "“眼神一变”话题冲上广场" },
];

export type GossipCard = {
  title: string;
  summary: string;
  author: string;
  tag: string;
  readMin: number;
  discuss: string;
  up: string;
  image?: string;
};

export const celebrities: GossipCard[] = [
  {
    title: "沈叙白：从“国民弟弟”到“撕番顶流”，一部剧让口碑两极",
    summary: "戏外比戏里还精彩。站位的讲究、进组的先后、宣传的排次……网友把这套“番位学”拆解得明明白白。",
    author: "影剧观察",
    tag: "明星八卦",
    readMin: 5,
    discuss: "1.2万",
    up: "今天 09:14",
    image: "https://readdy.ai/api/search-image?query=Stylized%20backlit%20silhouette%20of%20a%20young%20male%20actor%20in%20front%20of%20warm%20amber%20stage%20light%2C%20dramatic%20editorial%20portrait%2C%20moody%20vermillion%20and%20gold%20tones%2C%20cinematic%20press%20photography%20style%2C%20face%20hidden%20in%20shadow&width=900&height=600&seq=gossip-star-01&orientation=landscape",
  },
  {
    title: "苏晚晴三分钟回应信息量爆炸：婚变是假，立人设是真？",
    summary: "一句“清者自清”带过传闻，却用三分钟聊了恋爱观。网友逐帧分析语气，说这回应“话里有话”。",
    author: "情感雷达",
    tag: "网红主播",
    readMin: 4,
    discuss: "9.8千",
    up: "今天 07:42",
  },
  {
    title: "许之遥的转型赌注：童星光环之下，这次能撕下“可爱”标签吗",
    summary: "从甜美到暗黑，定妆照一出评论区立刻分成两派。转型若成功是突破，若失败便是全网群嘲的素材。",
    author: "娱乐观察站",
    tag: "明星八卦",
    readMin: 6,
    discuss: "6.3千",
    up: "昨天 22:18",
  },
  {
    title: "影帝顾沉舟的“沉默公关学”：不回应，有时就是最好的回应",
    summary: "被拍后工作室只发了一张风景照。粉丝说是气度，黑粉说是心虚，路人说：这招以静制动确实高级。",
    author: "公关显微镜",
    tag: "娱乐圈",
    readMin: 5,
    discuss: "8.1千",
    up: "昨天 19:05",
  },
  {
    title: "古偶小生周鹿片约不断，网友却开始担心“审美疲劳”",
    summary: "一年三部同题材，连造型都被做成对比图。流量仍在，但新鲜感还能撑多久，是粉丝也心慌的问题。",
    author: "片场快报",
    tag: "明星八卦",
    readMin: 4,
    discuss: "4.5千",
    up: "昨天 16:30",
  },
  {
    title: "陈知微凭综艺“毒舌”出圈，黑红也是红？",
    summary: "敢说真话是爽点，说过了头就是黑点。一场直播点评把这位演员送进热搜，也把她送上争议的十字路口。",
    author: "镜头背后",
    tag: "娱乐圈",
    readMin: 5,
    discuss: "7.0千",
    up: "前天 20:11",
  },
];

export const streamers: GossipCard[] = [
  {
    title: "百万粉美妆主播带货翻车全记录：从“全网安利”到“连夜道歉”",
    summary: "一场直播不到两小时，评论从“姐姐好美”刷成“退钱”。复盘这次翻车，最致命的不是选品，而是那句“家人们放心”。",
    author: "带货侦察连",
    tag: "网红主播",
    readMin: 7,
    discuss: "1.6万",
    up: "今天 08:20",
    image: "https://readdy.ai/api/search-image?query=Glossy%20magazine%20editorial%20still%20life%20of%20beauty%20cosmetics%20and%20a%20ring%20light%20on%20a%20warm%20beige%20desk%2C%20a%20smartphone%20showing%20a%20live%20stream%20interface%20in%20soft%20focus%2C%20crimson%20and%20amber%20toned%20product%20photography%2C%20clean%20and%20stylish&width=900&height=600&seq=gossip-stream-01&orientation=landscape",
  },
  {
    title: "头部主播孟离：一年带货百亿的账，真的经得起逐项盘点吗",
    summary: "低价是利器，也可能是一把双刃剑。当优惠被逐个“击穿”，粉丝信任与性价比之间，主播要如何自处？",
    author: "商业侦探",
    tag: "网红主播",
    readMin: 6,
    discuss: "1.1万",
    up: "昨天 21:47",
  },
  {
    title: "游戏主播陆清欢转战综艺翻红，老粉却喊“别忘本”",
    summary: "流量池换了一片，人设却开始“漂移”。跨界本是本事，但两头都想占，最容易两头都不讨好。",
    author: "电竞圈外",
    tag: "网红主播",
    readMin: 5,
    discuss: "5.6千",
    up: "昨天 14:33",
  },
  {
    title: "“塌房”之后翻盘？主播裴照用一场公益直播挽回口碑",
    summary: "从被全网抵制到重新被认可，中间隔的不是一句道歉，而是整整三个月的沉默与行动。这场翻身仗打得漂亮。",
    author: "危机公关所",
    tag: "网红主播",
    readMin: 6,
    discuss: "8.7千",
    up: "前天 18:09",
  },
  {
    title: "短视频顶流唐心停更一个月，粉丝开始全网“寻人”",
    summary: "流量最盛时选择消失，是变现跳板还是避风头？各种猜测满天飞，而她一个字都还没回。",
    author: "流量观察",
    tag: "网红主播",
    readMin: 4,
    discuss: "9.2千",
    up: "前天 11:26",
  },
  {
    title: "知识区主播江屿：讲错一个典故，被网友扒出十年旧账",
    summary: "人设越高，容错越低。一句口误引出十年前的小错，网友的态度是：要么你认，要么别立“百科全书”的人设。",
    author: "事实核对员",
    tag: "公众人物",
    readMin: 5,
    discuss: "6.8千",
    up: "3天前",
  },
];

export type TimelineEvent = {
  day: string;
  title: string;
  desc: string;
  status: "实锤" | "反转" | "辟谣" | "冷场";
};

export const impactTimeline: TimelineEvent[] = [
  { day: "08-31", title: "某品牌代言合同被曝“一页纸”，艺人连夜解约", desc: "声明发布前后不过三小时，反应之快被称作“教科书级止损”。品牌方尚未回应，事件仍在发酵。", status: "实锤" },
  { day: "09-02", title: "孟离被质疑“骨折价”，官方价目表一出反转", desc: "网友晒出对比截图，发现优惠后确实低于官方标价，风向从“抵制”迅速转为“真香”。", status: "反转" },
  { day: "09-03", title: "影帝“同行”实为多年好友，工作室晒聊天记录辟谣", desc: "一张带时间戳的聊天截图平息了围观，但也让不少人感叹：这次公关终于走对了一步棋。", status: "辟谣" },
  { day: "09-05", title: "某爱豆机场冷脸视频热传，粉丝与路人吵成一团", desc: "“高冷”还是“耍大牌”，同一段素材被剪出两个版本，舆论撕裂到连数据都开始打架。", status: "冷场" },
];

export type FeedItem = {
  time: string;
  tag: string;
  title: string;
  excerpt: string;
};

export const newsFeed: FeedItem[] = [
  { time: "10:26", tag: "综艺", title: "《下一站成团》官宣导师阵容，张予曦惊喜加盟", excerpt: "时隔两年再度营业，评论区“考古”话题阅读量三小时破亿。" },
  { time: "09:58", tag: "明星", title: "沈叙白工作室晒片场花絮，亲自下场回应番位争议", excerpt: "配文“戏比戏外更重要”，疑似喊话网友专注作品本身。" },
  { time: "09:31", tag: "网红", title: "唐心新账号深夜上线，停更一个月后首次更新动态", excerpt: "视频只有十二秒，却让粉丝连夜“认领”出是本人回归。" },
  { time: "08:47", tag: "娱乐圈", title: "音乐人程野新专定档，实体专辑三小时售罄", excerpt: "此前深陷封面撞款争议，作品销量却意外“用脚投票”给出答案。" },
  { time: "08:12", tag: "影剧", title: "《烟雨长街》官微放双人幕后照，被解读为“世纪和解”", excerpt: "一张同框照，让对线的两派粉丝集体“休战”一小时。" },
  { time: "07:40", tag: "网红", title: "美妆主播连夜更新质检报告，称“正在全面复核”", excerpt: "继昨日道歉直播后，团队发布三点整改说明，评论区仍有人不买账。" },
  { time: "06:55", tag: "体娱", title: "魏星野退役传闻再添实锤，赞助商已撤下相关物料", excerpt: "俱乐部至今未发公告，但多个线下物料被网友拍到已替换。" },
  { time: "06:20", tag: "明星", title: "许之遥新剧配音引争议，正主亲自下场回应“将重录”", excerpt: "一句“尊重观众意见”迅速圈粉，舆情开始出现明显反转。" },
];

export type FaqItem = { q: string; a: string };

export const faqs: FaqItem[] = [
  { q: "「刚刚爆料」的信息来源可靠吗？", a: "我们坚持标注信息来源与时间节点，对网络流传的路透、截图与聊天记录，会在转载时注明“未经证实”，并对需要核实的关键信息保留“待实锤”标签，帮助大家在追瓜时保持理性。" },
  { q: "为什么有些瓜会标注“待实锤”而不是直接下结论？", a: "娱乐圈信息鱼龙混杂，一张截图、一段剪过的视频都可能被断章取义。凡是尚无当事人或权威方确认的消息，我们一律以“传闻/待实锤”呈现，避免传播未经核实的说法。" },
  { q: "翻车、反转、辟谣、冷场这些标签分别代表什么？", a: "“实锤”指已有较充分佐证；“反转”指舆论方向出现明显变化；“辟谣”指当事人或相关方已公开否认；“冷场”指因信息不足或关注下降而暂时搁置。四类标签帮助大家快速判断事件所处阶段。" },
  { q: "我会在「刚刚爆料」上看到不实的娱乐八卦吗？", a: "我们会在能力范围内做到信息可溯源。但网络信息变化很快，若您发现内容与事实有出入，欢迎通过底部“爆料与纠错”通道反馈，我们核实后会第一时间更新或标注更正。" },
  { q: "如何理解娱乐圈的“人设”与真实形象之间的落差？", a: "艺人与公众之间本就存在“营业”与“生活”的边界。我们鼓励理性围观作品与业务能力，也尊重每个人作为普通人的一面，不以单一人设去定义任何人。" },
  { q: "网站会一直保持免费吗？", a: "「刚刚爆料」定位是轻松、开放的追瓜平台，核心内容长期免费阅读。我们通过少量品牌合作维持运营，合作内容都会明确标注，绝不混入新闻流干扰阅读。" },
];

export type VoiceItem = { name: string; role: string; text: string; like: string };

export const voices: VoiceItem[] = [
  { name: "饭后第一口", role: "每天蹲更的老瓜友", text: "界面清爽不花哨，瓜给得又全又新。最怕那些标题党，这里至少会把“传闻”和“实锤”分得明明白白，追起来心里有底。", like: "2.3万赞" },
  { name: "路过的铲屎官", role: "通勤路上看", text: "早高峰地铁上刷完一篇，刚好到站。标签分得很清楚，想看谁点谁，没有一堆乱七八糟的弹窗，体验比某博舒服多了。", like: "1.5万赞" },
  { name: "反向吃瓜", role: "理性围观型选手", text: "很多号喜欢一锤定音，这里却老老实实标“待实锤”，这点我挺欣赏。吃瓜可以，但别让谣言飞，追瓜也得讲基本法。", like: "9千赞" },
];

export type StatItem = { value: string; label: string };

export const stats: StatItem[] = [
  { value: "286万", label: "月度追瓜读者" },
  { value: "12万+", label: "累计实锤档案" },
  { value: "42位", label: "娱乐观察撰稿人" },
  { value: "99.6%", label: "读者满意度" },
];